import { useMemoizedFn } from 'ahooks';
import React, { useEffect } from 'react';
import { Form, Input, Table, Tag } from 'tdesign-react';
import { renderDateTime, renderOptions } from '@/utils/common';
import { getScriptList } from '@/services/templateService';
import useTable from '@/hooks/useTable';
import { clusterTypeOptions } from '@/utils/constant';

/**
 * @type {import('tdesign-react/lib/table/type').BaseTableCol}
 */
export const defaultColumns = [
  {
    colKey: 'row-select',
    type: 'multiple',
    fixed: 'left',
    width: 46,
  },
  {
    colKey: 'scriptName',
    title: '脚本名称',
    fixed: 'left',
    width: 160,
    cell: ({ row }) => (
      <>
        {row.systemScript && (
          <Tag style={{ marginRight: 6 }} size='small' theme='danger'>
            system
          </Tag>
        )}
        {row.scriptName}
      </>
    ),
  },
  {
    colKey: 'scriptNote',
    title: '脚本作用说明',
    width: 220,
    ellipsis: true,
  },
  {
    colKey: 'scriptOriginal',
    title: '脚本类型',
    options: clusterTypeOptions,
    cell: renderOptions,
    width: 120,
  },
  {
    colKey: 'scriptTypeText',
    title: '脚本语言',
    width: 100,
  },
  {
    title: '创建时间',
    colKey: 'createTime',
    cell: renderDateTime,
    width: 180,
  },
  {
    title: '更新时间',
    colKey: 'updateTime',
    cell: renderDateTime,
    width: 180,
  },
];

const { FormItem } = Form;

export default function ScriptTable({
  columns = defaultColumns,
  selectedRowData,
  onSelectChange,
  afterLoadData,
  extraPrams,
  operators,
  refreshEmmiter,
  selectOnRowClick,
}) {
  const selectedRowKeys = selectedRowData.map((item) => item.id);

  const loadData = useMemoizedFn(async (params) => {
    const { data } = await getScriptList(Object.assign(params, extraPrams));
    let { items } = data;
    // 二次处理数据
    if (afterLoadData) {
      items = afterLoadData(items);
    }
    setData(items, data.count);
  });

  const { header, config, setData, doSearch, doRefresh } = useTable({
    columns,
    search: (
      <FormItem name='scriptName'>
        <Input clearable placeholder='脚本名称' />
      </FormItem>
    ),
    operators,
    remote: true,
    onSearch: loadData,
  });

  if (refreshEmmiter) {
    refreshEmmiter.useSubscription(() => {
      doRefresh();
    });
  }

  useEffect(() => {
    doSearch();
  }, [doSearch]);

  return (
    <>
      {header}
      <Table
        {...config}
        rowKey='id'
        selectOnRowClick={selectOnRowClick}
        selectedRowKeys={selectedRowKeys}
        onSelectChange={onSelectChange}
      />
    </>
  );
}
